import React from "react"
import clsx from "clsx"
import PageBuilderConstants from "./constants/PageBuilderConstants"
import Row from "./Row"


class PageBuilderPage extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var self = this;

    var rows = [];

    for(var i = 0, ilen = self.props.rows.length; i < ilen; i++) {
      var row = self.props.rows[i];
      rows.push(<Row {...self.props} key={row.id} id={row.id} columns={row.columns} hideOnDevice={row.hideOnDevice} />);
    }

    var workspaceClasses = clsx({
      workspace: true,
      compose: this.props.mode === PageBuilderConstants.COMPOSE,
      desktop: this.props.mode === PageBuilderConstants.DESKTOP,
      tablet: this.props.mode === PageBuilderConstants.TABLET,
      cell: this.props.mode === PageBuilderConstants.CELL,
    });
    
    return (
      <div className={workspaceClasses} ref="workspace">
        <div className="container" ref="container">
          {rows}
        </div>
      </div>
    );
  }

};

export default PageBuilderPage
